import React, { useContext, useState } from 'react'
import { Box, Text, Anchor } from "grommet"
import TTLogo from '../../assets/ttlogo.png'
import UserContext from '../../context/UserContext'
import Clock from 'react-live-clock'

import { useWarnVersion } from '../../utils/warnVersion'
import { detect } from 'detect-browser';
import { ChosenBackend } from './backend'


const AppFooter = () => {

    const token = useContext(UserContext)
    const checkVersion = useWarnVersion()
    const thisBrowser = detect()
    const [warnBrowser] = useState(!(navigator.userAgent.indexOf("Chrome") !== -1))
    return (
        <>
            {checkVersion && checkVersion.warnVersion ? <WarnBar warnText={"You are using an older version of Control. Reload page or Click here to use latest release " + checkVersion.versionNumber + "."} /> : null}
            {warnBrowser && <WarnBar warnText="You are using an unsupported browser. Please Use the latest version of Chrome for best experience  as we do all testing on Chrome." />}

            <Box direction="row" justify="between" background="light-6">
                <Box justify="start" pad="xxsmall" background="light-6" direction="row">
                    <Box>
                        <img src={TTLogo} alt="Trading Technologies" height="20px" width="80px" />
                    </Box>
                    <Text size="small" color="dark-2" margin={{ left: "small" }}>
                        TT Control Center {(new Date()).getFullYear()}
                        (<Anchor href="https://github.com/tradingtechnologies/platform-engineering/blob/master/frontend/ttcontrol/CHANGELOG.md" target="_blank">
                            {process.env.REACT_APP_VERSION}
                        </Anchor>)
                        running on <Text size="small" weight='bold'>{thisBrowser.os}</Text> with <Text size="small" weight='bold' color=''>{thisBrowser.name} ({thisBrowser.version})</Text> on backend: <Text size="small" weight='bold' color=''>{ChosenBackend().replace("/v1/graphql", "")}</Text>
                </Text>
            </Box>
            <Box justify="end" pad="xxsmall" background="light-6" direction="row" gap="small" margin={{ right: "xsmall" }}>
                <Text size="small" color="dark-2">
                    {token.user_email}
                </Text>
                <Clock format={'MMM Do YYYY, HH:mm:ss ZZ'} ticking={true} timezone={token.timezone} />
            </Box>
        </Box >
        </>
    )
}

const WarnBar = ({ warnText }) => (
    <Box background="ttpartial" border={{ side: "horizontal", type: "dotted" }} onClick={() => window.location.reload()}>
        <Box direction="row" justify="between" background="ttpartial" pad="none">
            <Text margin={{ left: "xsmall" }} size="small" color="ttdown">{warnText}</Text>
        </Box>
    </Box>
)

export default AppFooter